export default "__VITE_ASSET__b756Sk7I__"